import date from 'locutus/php/datetime/date'

export default function formatDate(dateString, format) {
  if (!dateString) return '-'

  const inputDate =
    typeof dateString !== 'number' && !isNaN(dateString) && dateString.charAt(0) === '@'
      ? parseInt(dateString.substring(1))
      : new Date(dateString)
  return date(format, inputDate)
}
